const breadcrumbFolderLastUpFile = (breadcrumb = [], action) => {
    switch (action.type) {
      case "SET_BREADCRUMB_FOLDER_LAST_UP_FILE":
        return action.breadcrumb
      default:
        return breadcrumb;
    }
  };
export default breadcrumbFolderLastUpFile;
  